import React from 'react';
import CheckBox from '../../../../components/check-box';
import FormLabel from '../../../../components/form/label/label';
import './ssm-checkbox.css';

const SSMCheckBox = (props) => {
  const { checkBoxId, checkBoxLabel, checkBoxDesc, checkBoxChecked, onCheckBoxStatusChanged } = props;
  return (
    <div className="checkboxes-wrap">
      <CheckBox
        id={checkBoxId}
        iconType="tick"
        checked={checkBoxChecked}
        callBackAction={onCheckBoxStatusChanged}
      />
      <FormLabel label={checkBoxLabel} forId={checkBoxId} />
      <p id="main-description" className="checkbox-description">{checkBoxDesc}</p>
    </div>
  );
};

export default SSMCheckBox;
